var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/classof-raw.js
// module id = 37
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35